import { resolveApiEnvironment } from "@/shared/lib/env/environment"

export type SentryEnvironment =
  | "local"
  | "development"
  | "production"
  | "unknown"

/** Where the frontend runs; the API it calls is recorded separately. */
export const resolveSentryEnvironment = ({
  hostname,
  isDevServer,
}: {
  hostname: string
  isDevServer: boolean
}): SentryEnvironment => {
  const host = hostname.toLowerCase()
  if (
    isDevServer ||
    host === "localhost" ||
    host.endsWith(".localhost") ||
    host === "127.0.0.1" ||
    host === "::1" ||
    host === "[::1]"
  )
    return "local"
  if (host === "dev.console.beringlab.com") return "development"
  if (host === "app.beringlab.com") return "production"
  return "unknown"
}

export const sentryEnvironmentOptions = ({
  hostname,
  isDevServer,
  apiBaseUrl,
}: {
  hostname: string
  isDevServer: boolean
  apiBaseUrl: string | undefined
}) => ({
  environment: resolveSentryEnvironment({ hostname, isDevServer }),
  initialScope: {
    tags: { api_environment: resolveApiEnvironment(apiBaseUrl) },
  },
})
